import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-6" }
const _hoisted_3 = { class: "col-6" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-6" }
const _hoisted_6 = { class: "col-6" }
const _hoisted_7 = { class: "dialog-footer" }

import { ref } from "vue";
import UserService from "@/projects/tenant/modules/users/services/UserService";
import { ApplicationStatusType } from "@/core/types/ApplicationInfos";


export default /*#__PURE__*/_defineComponent({
  __name: 'SocialMediaFormModal',
  emits: ["application-submitted"],
  setup(__props, { expose: __expose, emit: emits }) {

const isLoading = ref(false);
const socialMediaRef = ref(false);
const partyId = ref(0);
const formType = ref("");
const item = ref({
  name: "",
  account: "",
  connectId: "",
  staffName: "",
});

const socialMediaOptions = [
  { label: "Facebook", value: "facebook" },
  { label: "Twitter", value: "twitter" },
  { label: "Instagram", value: "instagram" },
  { label: "LinkedIn", value: "linkedIn" },
  { label: "WeChat", value: "weChat" },
  { label: "WhatsApp", value: "whatsApp" },
  { label: "Telegram", value: "telegram" },
  { label: "Line", value: "line" },
];



const update = async () => {
  isLoading.value = true;
  try {
    await UserService.putSocialMediaInfo(partyId.value, item.value);
    emits("application-submitted");
    hide();
  } catch (error) {
    console.error(error);
  }
  isLoading.value = false;
};

const show = (_partyId, _type, _item?) => {
  partyId.value = _partyId;
  formType.value = _type;
  if (_type === "edit") item.value = JSON.parse(JSON.stringify(_item));
  socialMediaRef.value = true;
};

const hide = () => {
  socialMediaRef.value = false;
  formType.value = "";
  item.value = {
    name: "",
    account: "",
    connectId: "",
    staffName: "",
  };
};

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: socialMediaRef.value,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((socialMediaRef).value = $event)),
    title: "Social Media",
    width: "800",
    "align-center": "",
    class: "rounded",
    "before-close": hide
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (socialMediaRef.value = false)),
          disabled: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: update,
          loading: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.update")), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref: "ruleFormRef",
        model: item.value,
        "label-position": "top"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (formType.value == 'edit')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 0,
                    label: "App Name",
                    prop: "appName"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        value: _ctx.$t('fields.' + item.value.name),
                        disabled: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (formType.value == 'create')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 1,
                    label: "App Name ( Contact IT to add more app )",
                    prop: "appName"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: item.value.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((item.value.name) = $event))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(socialMediaOptions, (item) => {
                            return _createVNode(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"])
                          }), 64))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_form_item, {
                label: "Account ID",
                prop: "accountId"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: item.value.account,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((item.value.account) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_form_item, {
                label: "BCR Connect ID",
                prop: "BCRConnectId"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: item.value.connectId,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((item.value.connectId) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_el_form_item, {
                label: "Staff Name",
                prop: "staffName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: item.value.staffName,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((item.value.staffName) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})